/**
 * Ajuda Module Routes
 * Stories: 13.1, 13.2
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const FAQPage = lazy(() => import("@/pages/ajuda/FAQ"));
const GlossaryPage = lazy(() => import("@/pages/ajuda/GlossaryPage"));

export const ajudaRoutes: ModuleRoutes = {
  moduleId: "ajuda",
  basePath: "/ajuda",
  routes: [
    // Rotas publicas (sem permissao)
    {
      path: "/ajuda/faq",
      element: <FAQPage />,
    },
    {
      path: "/ajuda/glossario",
      element: <GlossaryPage />,
    },
  ],
};
